import React, { useState } from 'react';
import {
  Row,
  Col,
  Collapse,
  Form,
  Input,
  // DatePicker,
  // Select,
  Radio,
  Space,
  // Image,
  message,
  Upload,
  Button,
  Tag,
  Spin
  // Card
} from 'antd';
import FormItem from '@/common/FormItem';
import styles from '@/common/Layout/index.module.less';
import CustomButton from '@/common/CustomButton';
// import truck from '../images/truck-delivery-done.gif';
import { useDispatch } from 'react-redux';
import {
  // getAllMaterialslist,
  createMaterialInward
  // getAllSuppliers
} from '../../redux/slice';
// import dayjs from 'dayjs';
import { history } from 'app/history';
// import { removeDuplicatesFromArray } from 'utilities/helpers';
import { PaperClipOutlined } from '@ant-design/icons';

// import moment from 'moment';

const { Panel } = Collapse;
const { TextArea } = Input;

const CreateMaterialPage = ({ loading }) => {
  // const { MaterialsList } = useSelector((state) => state.material);
  const dispatch = useDispatch();

  const [form] = Form.useForm();

  const [truckShow, setTruckShow] = useState(false);
  const [material, setMaterial] = useState({});
  const [fileList, setFileList] = useState([]);
  console.log(setFileList);
  // const [search, setSearch] = useState('');
  // const [code, setCode] = useState('');
  // const [searchvendor, setSearchvendor] = useState('');
  // const [suppliersdata, setSuppliersdata] = useState([]);
  // const [manufacturer, setManufacturer] = useState();
  // const [selectVendor, setSelectVendor] = useState();
  // const current = new Date();
  // const month =
  //   `${current.getMonth() + 1}`.length > 2
  //     ? `${current.getMonth() + 1}`
  //     : `0${current.getMonth() + 1}`;
  // const date = `${current.getFullYear()}-${month}-${current.getDate()}`;
  // useEffect(() => {
  //   handleGetAllMaterialsList();
  // }, []);
  // useEffect(() => {
  //   handleGetAllSuppliers();
  // }, [searchvendor]);
  // useEffect(() => {
  //   form.setFieldsValue({
  //     material_name: code?.name,
  //     supplier_id: '',
  //     uom: code?.uom,
  //     mfg_name: '',
  //     vendor_status: ''
  //   });
  // }, [code]);
  // useEffect(() => {
  //   form.setFieldsValue({
  //     mfg_name: manufacturer ? manufacturer[0]?.manufacturer_name : '',
  //     vendor_status: manufacturer ? manufacturer[0]?.vendor_status : ''
  //   });
  // }, [manufacturer]);
  // const onChange = (value) => {
  //   const material = MaterialsList.filter(
  //     (MaterialsList) => MaterialsList.id === value
  //   );
  //   console.log(material);
  //   setCode(material[0]);
  //   setSuppliersdata(material[0].suppliers);
  //   setSelectVendor('');
  // };

  // const onChangeSupplier = (value) => {
  //   const manufacturerData = suppliersdata.filter(
  //     (suppliersdata) => suppliersdata.id === value
  //   );
  //   setManufacturer(manufacturerData);
  // };
  // console.log(manufacturer);
  // const onSearch = (value) => {
  //   setSearch(value);
  // };

  // const onSearchvendor = (value) => {
  //   setSearchvendor(value);
  // };
  const handleCapacity = (e) => {
    const { name, value } = e.target;
    setMaterial({ ...material, [name]: value });
  };

  const handleOnChangePdfUpload = (info) => {
    setFileList(info.fileList);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo.errorFields.length);
    if (errorInfo.errorFields.length > 0) {
      message.error('Please fill all the details to proceed further.');
    }
  };
  const onFinish = (values) => {
    // Document Verification - call 'document/create' API
    let files = [];
    fileList.forEach((data) => {
      if (data.originFileObj) {
        files.push(data.originFileObj);
      }
    });

    let formData = new FormData();
    formData.append('for_graviti', material.gravity);
    formData.append('po_available', material.po_available);
    formData.append('invoice_number', values.invoice_number);
    formData.append(
      'invoice_dc_boe_available',
      material.invoice_dc_boe_available
    );
    formData.append('material_vendor_status', material.material_vendor_status);
    formData.append(
      'manufacture_site_address_matching',
      material.manufacture_site_address_matching
    );
    formData.append('coa_coc_msda_available', material.coa_coc_msda_available);
    formData.append('doc_ver_comments', values.comments || '');

    for (let i = 0; i < files.length; i++) {
      formData.append('files', files[i]);
    }

    setTruckShow(true);

    dispatch(createMaterialInward(formData)).then(function (response) {
      if (response?.payload?.success) {
        setTimeout(() => {
          localStorage.setItem(
            'invoice_num',
            response?.payload?.data?.invoice_number || ''
          );
          message.success(response?.payload?.message);
          history.push('/pending-receipts');
        }, 2000);
      } else {
        setTruckShow(false);
        message.error(response?.payload?.message || 'Failed to submit');
      }
    });
  };

  // const handleGetAllMaterialsList = () => {
  //   let payload = { search };
  //   dispatch(getAllMaterialslist(payload));
  // };

  // const handleGetAllSuppliers = () => {
  //   let payload = { search };
  //   dispatch(getAllSuppliers(payload));
  // };

  // const disabledDate = (current) => {
  //   return current && current > dayjs().endOf('day');
  // };

  // const handleSeldctVendor = (value) => {
  //   setSelectVendor(value);
  // };

  const handleStandardCancel = () => {
    history.push('/dashboard');
  };

  // Save draft function - validates form before saving and calls appropriate API
  // const handleSaveDraft = (panelKey, e) => {
  //   // Prevent default form submission
  //   if (e) {
  //     e.preventDefault();
  //     e.stopPropagation();
  //   }

  //   // Define fields for each panel
  //   const panelFields = {
  //     1: [
  //       'gravity',
  //       'invoice_dc_boe_available',
  //       'invoice_number',
  //       'po_available',
  //       'coa_coc_msda_available',
  //       'material_vendor_status',
  //       'manufacture_site_address_matching',
  //       'comments'
  //     ],
  //     2: [
  //       'vehicle_cleanliness',
  //       'storage_enclose',
  //       'storage_conditions',
  //       'veh_storage_comments'
  //     ],
  //     3: [
  //       'data_logger',
  //       'labels_defaced',
  //       'dedusting_status',
  //       'seal_integrity',
  //       'material_ver_comments'
  //     ]
  //   };

  //   // Validate only the fields in the current panel
  //   const fieldsToValidate = panelFields[panelKey] || [];

  //   form
  //     .validateFields(fieldsToValidate)
  //     .then(() => {
  //       // Validation passed - get form values
  //       const formValues = form.getFieldsValue();
  //       let files = [];
  //       fileList.forEach((data) => {
  //         if (data.originFileObj) {
  //           files.push(data.originFileObj);
  //         }
  //       });

  //       let formData = new FormData();

  //       if (panelKey === '1') {
  //         // Panel 1: Document Verification - call 'document/create' API
  //         formData.append('for_graviti', material.gravity);
  //         formData.append('po_available', material.po_available);
  //         formData.append('invoice_number', formValues.invoice_number);
  //         formData.append(
  //           'invoice_dc_boe_available',
  //           material.invoice_dc_boe_available
  //         );
  //         formData.append(
  //           'material_vendor_status',
  //           material.material_vendor_status
  //         );
  //         formData.append(
  //           'manufacture_site_address_matching',
  //           material.manufacture_site_address_matching
  //         );
  //         formData.append(
  //           'coa_coc_msda_available',
  //           material.coa_coc_msda_available
  //         );
  //         formData.append('doc_ver_comments', formValues.comments);
  //         for (let i = 0; i < files.length; i++) {
  //           formData.append('files', files[i]);
  //         }

  //         setTruckShow(true);
  //         dispatch(createMaterialInward(formData)).then(function (response) {
  //           setTruckShow(false);
  //           if (response?.payload?.success) {
  //             message.success('Document verification saved successfully');
  //           } else {
  //             message.error(
  //               response?.payload?.message ||
  //                 'Failed to save document verification'
  //             );
  //           }
  //         });
  //       } else {
  //         // Panel 2 or 3: Vehicle Storage or Material Verification - call 'document/create_vehicle_storage' API
  //         formData.append('vehicle_cleanliness', material.vehicle_cleanliness);
  //         formData.append('storage_conditions', material.storage_conditions);
  //         formData.append('storage_enclose', material.storage_enclose);
  //         formData.append(
  //           'vehicle_storage_comments',
  //           formValues.veh_storage_comments || ''
  //         );
  //         formData.append('data_logger', material.data_logger);
  //         formData.append('dedusting_status', material.dedusting_status);
  //         formData.append('labels_defaced', material.labels_defaced);
  //         formData.append('seal_integrity', material.seal_integrity);
  //         formData.append(
  //           'material_ver_comments',
  //           formValues.material_ver_comments || ''
  //         );

  //         setTruckShow(true);
  //         dispatch(createVehicleStorage(formData)).then(function (response) {
  //           setTruckShow(false);
  //           if (response?.payload?.success) {
  //             message.success(
  //               panelKey === '2'
  //                 ? 'Vehicle storage saved successfully'
  //                 : 'Material verification saved successfully'
  //             );
  //           } else {
  //             message.error(response?.payload?.message || 'Failed to save');
  //           }
  //         });
  //       }
  //     })
  //     .catch((errorInfo) => {
  //       // Validation failed - show error message
  //       console.log('Validation failed:', errorInfo);
  //       message.error('Please fill all required fields before saving draft.');
  //     });
  // };

  // const preventDefault = (e) => {
  //   e.preventDefault();
  //   console.log('Clicked! But prevent default.');
  // };
  const handleDelete = (removedTag) => {
    const newTags = fileList.filter((tag) => tag.name !== removedTag);
    setFileList(newTags);
  };

  console.log(fileList);
  // const Statuses = [
  //   {
  //     label: 'Provisional ',
  //     valu: 'provisional '
  //   },
  //   {
  //     label: 'Approved',
  //     valu: 'approved'
  //   }
  // ];

  // const dateFormat = 'YYYY-MM-DD';

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      className={styles.panelborder}
    >
      <Collapse defaultActiveKey={['1']} accordion orceRender={true}>
        <Panel
          header="DOCUMENT VERIFICATION"
          key="1"
          className={styles.CustomPanel}
          forceRender={true}
        >
          <Row gutter={24}>
            <Col xs={24} xl={8} span={8}>
              <FormItem
                label="Is the material meant for graviti?"
                name="gravity"
                rules={[
                  {
                    required: true,
                    message: 'Choose Yes/No'
                  }
                ]}
                className={styles.customLable}
              >
                <Radio.Group
                  onChange={handleCapacity}
                  className={styles.customRadio}
                  name="gravity"
                >
                  <Radio value="Yes">Yes</Radio>
                  <Radio value="No">No</Radio>
                </Radio.Group>
              </FormItem>
            </Col>

            <Col xs={24} xl={8} span={8}>
              <FormItem
                label="Invoice/DC/BOE Number available"
                name="invoice_dc_boe_available"
                rules={[
                  {
                    required: true,
                    message: 'Choose Yes/No'
                  }
                ]}
                className={styles.customLable}
              >
                <Radio.Group
                  onChange={handleCapacity}
                  className={styles.customRadio}
                  name="invoice_dc_boe_available"
                >
                  <Radio value="Yes">Yes</Radio>
                  <Radio value="No">No</Radio>
                </Radio.Group>
              </FormItem>
            </Col>
            {/* <Col xs={24} xl={8} span={8}>
              <FormItem
                label="DC available?"
                name="dc"
                rules={[
                  {
                    required: true,
                    message: 'Choose Yes/No'
                  }
                ]}
                className={styles.customLable}
              >
                <Radio.Group
                  onChange={handleCapacity}
                  className={styles.customRadio}
                  name="dc"
                >
                  <Radio value="Yes">Yes</Radio>
                  <Radio value="No">No</Radio>
                </Radio.Group>
              </FormItem>
            </Col>
            <Col xs={24} xl={8} span={8}>
              <FormItem
                label="BOE available?"
                name="boe"
                rules={[
                  {
                    required: true,
                    message: 'Choose Yes/No'
                  }
                ]}
                className={styles.customLable}
              >
                <Radio.Group
                  onChange={handleCapacity}
                  className={styles.customRadio}
                  name="boe"
                >
                  <Radio value="Yes">Yes</Radio>
                  <Radio value="No">No</Radio>
                </Radio.Group>
              </FormItem>
            </Col> */}
            <Col xs={24} xl={8} span={8}>
              <FormItem
                label="Invoice/DC/BOE Number"
                name="invoice_number"
                rules={[
                  {
                    required: true,
                    message: 'Enter Invoice number'
                  }
                ]}
                className={styles.customLable}
              >
                <Input placeholder="Enter Invoice number" />
              </FormItem>
            </Col>
            <Col xs={24} xl={8} span={8}>
              <FormItem
                label="Purchase Order available"
                name="po_available"
                rules={[
                  {
                    required: true,
                    message: 'Choose Yes/No'
                  }
                ]}
                className={styles.customLable}
              >
                <Radio.Group
                  onChange={handleCapacity}
                  className={styles.customRadio}
                  name="po_available"
                >
                  <Radio value="Yes">Yes</Radio>
                  <Radio value="No">No</Radio>
                </Radio.Group>
              </FormItem>
            </Col>
            <Col xs={24} xl={8} span={8}>
              <FormItem
                label="COA/COC, MSDS available"
                name="coa_coc_msda_available"
                rules={[
                  {
                    required: true,
                    message: 'Choose Yes/No'
                  }
                ]}
                className={styles.customLable}
              >
                <Radio.Group
                  onChange={handleCapacity}
                  className={styles.customRadio}
                  name="coa_coc_msda_available"
                >
                  <Radio value="Yes">Yes</Radio>
                  <Radio value="No">No</Radio>
                </Radio.Group>
              </FormItem>
            </Col>
            <Col xs={24} xl={8} span={8}>
              <FormItem
                label="Material Vendor Status"
                name="material_vendor_status"
                rules={[
                  {
                    required: true,
                    message: 'Choose Yes/No'
                  }
                ]}
                className={styles.customLable}
              >
                <Radio.Group
                  onChange={handleCapacity}
                  className={styles.customRadio}
                  name="material_vendor_status"
                >
                  <Radio value="approved">Approved</Radio>
                  <Radio value="prov">Provisionally Approved</Radio>
                  <Radio value="New">New</Radio>
                </Radio.Group>
              </FormItem>
            </Col>
            {/* <Col xs={24} xl={8} span={8}>
              <FormItem
                label="COA available?"
                name="coa"
                rules={[
                  {
                    required: true,
                    message: 'Choose Yes/No'
                  }
                ]}
                className={styles.customLable}
              >
                <Radio.Group
                  onChange={handleCapacity}
                  className={styles.customRadio}
                  name="coa"
                >
                  <Radio value="Yes">Yes</Radio>
                  <Radio value="No">No</Radio>
                </Radio.Group>
              </FormItem>
            </Col>
            <Col xs={24} xl={8} span={8}>
              <FormItem
                label="COC available?"
                name="coc"
                rules={[
                  {
                    required: true,
                    message: 'Choose Yes/No'
                  }
                ]}
                className={styles.customLable}
              >
                <Radio.Group
                  onChange={handleCapacity}
                  className={styles.customRadio}
                  name="coc"
                >
                  <Radio value="Yes">Yes</Radio>
                  <Radio value="No">No</Radio>
                </Radio.Group>
              </FormItem>
            </Col> */}
            <Col span={16}>
              <FormItem
                label="Manufacturing site address matching with Provisionally
                Approved/Approved Vendor list"
                name="manufacture_site_address_matching"
                rules={[
                  {
                    required: true,
                    message: 'Choose Yes/No'
                  }
                ]}
                className={styles.customLable}
              >
                <Radio.Group
                  onChange={handleCapacity}
                  className={styles.customRadio}
                  name="manufacture_site_address_matching"
                >
                  <Radio value="Yes">Yes</Radio>
                  <Radio value="No">No</Radio>
                </Radio.Group>
              </FormItem>
            </Col>
            <Col xs={24} xl={8} span={8}>
              <FormItem
                label="Upload a File"
                // name="coa_coc_msda_available"
                rules={[
                  {
                    required: true,
                    message: 'Choose Yes/No'
                  }
                ]}
                className={styles.customLable}
              >
                <Upload
                  // accept=".pdf"
                  fileList={fileList}
                  className={`avatar-uploader ${styles.upload}`}
                  onChange={handleOnChangePdfUpload}
                  customRequest={({ onSuccess }) => {
                    setTimeout(() => {
                      onSuccess('ok');
                    }, 0);
                  }}
                  multiple={true}
                  showUploadList={false}
                >
                  <Button
                    icon={<PaperClipOutlined />}
                    className={styles.upload_button}
                    style={{ width: '100%' }}
                  >
                    Attach File
                  </Button>
                </Upload>
                <br />
                <br />
                <Space direction="vertical">
                  {fileList.length > 0
                    ? fileList.map(({ name, index }) => (
                        <Tag
                          closable
                          onClose={(e) => {
                            e.preventDefault();
                            handleDelete(name);
                          }}
                          key={index}
                        >
                          {name}
                        </Tag>
                      ))
                    : ''}
                </Space>
              </FormItem>
            </Col>
            <Col xs={24} xl={24} span={8}>
              <FormItem
                label="Comments"
                name="comments"
                rules={[
                  {
                    required: false,
                    message: 'Choose Yes/No'
                  }
                ]}
                className={styles.customLable}
              >
                <TextArea placeholder="Enter comments"></TextArea>
              </FormItem>
            </Col>
          </Row>
          <FormItem className="text-center" style={{ marginTop: '20px' }}>
            <Space>
              <CustomButton
                htmlType="button"
                onClick={handleStandardCancel}
                className={styles.border_button}
              >
                Cancel
              </CustomButton>
              {truckShow ? (
                <Spin size="large" />
              ) : (
                <CustomButton
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  className={styles.border_button}
                >
                  Submit
                </CustomButton>
              )}
            </Space>
          </FormItem>
        </Panel>
      </Collapse>
    </Form>
  );
};
export default CreateMaterialPage;
